import { createSlice } from "@reduxjs/toolkit";

export type QuoteListType = {
  total: number;
  page: number;
  page_size: number;
  data: any[];
};

export type CustomerQuoteListResponse = {
  status?: string;
  data?: {
    sessions?: any[];
  };
};

export type QuoteState = {
  quoteList: QuoteListType | null;
  customerQuoteList: CustomerQuoteListResponse | null;
};

const initialState: QuoteState = { quoteList: null, customerQuoteList: null };

const quoteSlice = createSlice({
  name: "quote",
  initialState,
  reducers: {
    quoteList: (state, action: { payload: QuoteState["quoteList"] }) => {
      state.quoteList = action.payload;
    },
    customerQuoteList: (state, action: { payload: CustomerQuoteListResponse }) => {
      state.customerQuoteList = action.payload;
    },
  },
});

export const { quoteList, customerQuoteList } = quoteSlice.actions;
export default quoteSlice.reducer;
